import React from "react";
import { Alert, Card, CardContent, Stack, Typography } from "@mui/material";

const TrialExpiredCard = ({ companyName, trialEndsAt }) => {
  return (
    <Card variant="outlined" sx={{ borderRadius: 3 }}>
      <CardContent>
        <Stack spacing={2}>
          <Typography variant="h6" fontWeight={700}>
            Trial Expired
          </Typography>

          <Alert severity="error">
            The trial period for {companyName || "your company"} has ended
            {trialEndsAt ? ` on ${trialEndsAt}` : ""}.
          </Alert>

          <Typography variant="body2" color="text.secondary">
            To continue using the service, please review the license options
            below, calculate the price, and proceed with payment.
          </Typography>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default TrialExpiredCard;
